// extracted by mini-css-extract-plugin
export default {"buttonInsta":"Insta_buttonInsta__fDwQM","buttonInstaImg":"Insta_buttonInstaImg__NRCXY"};